var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "locale-switcher" },
    [
      _vm.$store.getters.isAuthenticated
        ? _c(
            "v-menu",
            {
              attrs: { "offset-y": "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              { attrs: { color: "secondary" } },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [_vm._v(" " + _vm._s(_vm.$i18n.locale) + " ")]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                866016319
              )
            },
            [
              _c(
                "v-list",
                _vm._l(_vm.locales, function(locale) {
                  return _c(
                    "v-list-item",
                    { key: locale.code },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", block: "" },
                          on: {
                            click: function($event) {
                              return _vm.changeLocale(locale.code)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(locale.name) + " ")]
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }